function startCountdown() {
  function updateTimerDisplay(hours, minutes, seconds, message, subMessage) {
    hoursElement.innerHTML = hours < 10 ? "0" + hours : hours;
    minutesElement.innerHTML = minutes < 10 ? "0" + minutes : minutes;
    secondsElement.innerHTML = seconds < 10 ? "0" + seconds : seconds;
    document.querySelector(".countdown-header h4").innerHTML = message;
    document.querySelector(".countdown-header-text").innerHTML = subMessage;
  }

  function calculateTimeRemaining() {
    var now = new Date();
    var day = now.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
    var deadline = new Date();
    var message = "";
    var subMessage = "";
    var countdownElement = document.querySelector(".custom-countdown");

    if (day === 6 || day === 0) {
      // Weekend logic: countdown to 3 PM Monday
      deadline.setDate(now.getDate() + ((8 - day) % 7));
      deadline.setHours(15, 0, 0, 0);
      message = "Want it by Tuesday?";
      subMessage = "Weekend Orders Will be Dispatched on Monday";
      // Hide countdown on weekends
      countdownElement.classList.add("hide-countdown");
    } else {
      // Show countdown on weekdays
      countdownElement.classList.remove("hide-countdown");
      if (now.getHours() < 15) {
        // Before 3 PM: countdown for next day delivery
        deadline.setHours(15, 0, 0, 0);
        message = "Want it by tomorrow?";
        subMessage = "Order by 3pm & choose next working day delivery.";
      } else {
        // After 3 PM: countdown for delivery day after tomorrow
        deadline.setDate(now.getDate() + 1);
        deadline.setHours(15, 0, 0, 0);

        // Get the delivery day name
        var deliveryDay = new Date(deadline);
        deliveryDay.setDate(deliveryDay.getDate() + 1);
        const options = { weekday: "long", day: "numeric", month: "long" };
        message = `Want it by ${deliveryDay.toLocaleDateString(
          "en-GB",
          options
        )}?`;
        subMessage =
          "Choose next day delivery";
      }
    }

    var timeRemaining = deadline - now;
    var hours = Math.floor(
      (timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    var minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

    updateTimerDisplay(hours, minutes, seconds, message, subMessage);

    if (timeRemaining < 0) {
      clearInterval(interval);
      updateTimerDisplay(0, 0, 0, message, subMessage);

    }
  }

  var hoursElement = document.getElementById("hours");
  var minutesElement = document.getElementById("minutes");
  var secondsElement = document.getElementById("seconds");

  var interval = setInterval(calculateTimeRemaining, 1000);
}

function initializeCountdown() {
  setTimeout(startCountdown, 1); // 0.01-second delay
}

document.addEventListener("DOMContentLoaded", initializeCountdown);

// Fallback for AJAX-loaded content
var targetNode = document.body;
var config = { childList: true, subtree: true };

var callback = function (mutationsList, observer) {
  for (var mutation of mutationsList) {
    if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
      if (document.querySelector(".custom-countdown")) {
        initializeCountdown();
        observer.disconnect();
        break;
      }
    }
  }
};

var observer = new MutationObserver(callback);
observer.observe(targetNode, config);
